import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import styles from "./Cadastro.module.css";
import { useNavigate } from "react-router-dom";
import { FormProvider, useForm } from "react-hook-form";
import servSolicitacaoFiscalizacao from "../../../services/login/servSolicitacaoFiscalizacao";
import { defaultValues, schema } from "./Validacoes";
import { yupResolver } from "@hookform/resolvers/yup";
import { ErrorHandling } from "../../../components/Errors/Errors";
import { logout } from "../../../state/slices/userSlice";
import { format, parse } from "date-fns";
import ptBR from "date-fns/locale/pt-BR/";
import { Alert, Box, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Modal, Snackbar, Tab, Tabs } from "@mui/material";
import TabPanel from "../../../components/Tabpanel/Tabpanel";
import { Geral } from "./Abas/Geral";
import { Documentos } from "./Abas/Documentos";
import servAnalises from "../../../services/login/servAnalises";
import servSolicitacaoCompartilhamento from "../../../services/login/servSolicitacaoCompartilhamento";
import { style as modalstyle } from "../../../components/Loading/Loading";
import { BlueHoverButton } from "../../../components/Inputs/BlueHoverButton";
import servSolicitacaoFiscalizacaoDocs from "../../../services/login/servSolicitacaoFiscalizacaoDocs";
import servParam from "../../../services/login/servParam";
import useStateRef from "react-usestateref";

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const Cadastro = ({
  pesquisar,
  recordForEdit,
  setOpen,
  novoCadastro,
  setEhNovoCadastro }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const methods = useForm({ defaultValues: defaultValues, resolver: yupResolver(schema) });
  const user = useSelector(state => state.user);
  const solicCompartilhamento = methods.watch("SolicitacaoCompartilhamento")

  const [tabIndex, setTabIndex] = useState(0);
  const [podeSalvar, setPodeSalvar] = useState(true);

  const [openError, setOpenError] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const [typeAlert, setTypeAlert] = useState("error");
  const [isLoading, setIsLoading] = useState(false);

  const [solicitacaoCompartilhamento, setSolicitacaoCompartilhamento] = useState(null);
  const [fecharAoSalvar, setFecharAoSalvar, fecharAoSalvarRef] = useStateRef(true);
  const [documentosObrigatorios, setDocumentosObrigatorios] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [disableUpload, setDisableUpload] = useState(false);
  const [disableCampos, setDisableCampos] = useState(false);
  const [situacao, setSituacao] = useState(0);

  useEffect(() => {
    const recuperarAnaliseSolicComp = async () => {
      try {
        setIsLoading(true);

        const solicitacao = await servSolicitacaoCompartilhamento.listarCFiltrosComCodigo(user.codigoUsuario, solicCompartilhamento.Id || solicCompartilhamento.value);

        solicitacao.Content && setSolicitacaoCompartilhamento(solicitacao.Content[solicitacao.Content.length - 1]);

        setIsLoading(false);
      } catch (err) {
        setIsLoading(false);
      }
    }

    if (solicCompartilhamento) {
      recuperarAnaliseSolicComp();
    }
  }, [solicCompartilhamento]);

  useEffect(() => {
    const situacoesBloqueadas = [1, 4, 6, 7, 8];

    if (recordForEdit !== null) {
      const recuperarDadosParaEdicao = async () => {
        try {
          setIsLoading(true);

          const data = await servSolicitacaoFiscalizacao.RecuperarParaEditar(recordForEdit.Id);

          mapearRetorno(data.Content);
          setSituacao(data?.Content?.SituacaoFiscalizacao);

          setIsLoading(false);
        } catch (err) {
          setIsLoading(false);

          return ErrorHandling(
            err?.request?.status,
            err?.message,
            setOpenError,
            setErrorMessage,
            dispatch,
            logout,
            navigate,
            err?.response?.data?.Message
          );
        }
      }

      recuperarDadosParaEdicao();
      recuperarDocumentosIniciais();

      if (situacoesBloqueadas.includes(recordForEdit?.SituacaoFiscalizacao)) {
        setPodeSalvar(false);
        setDisableUpload(true);
        setDisableCampos(true);
      }
    }
  }, [recordForEdit]);

  const mapearRetorno = (data) => {
    methods.setValue("Id", data.Id);
    methods.setValue("NumeroFiscalizacao", data.NumeroFiscalizacao);
    methods.setValue("SituacaoFiscalizacao", data.SituacaoFiscalizacao);
    methods.setValue("NumeroAnalise", data.NumeroAnalise);
    methods.setValue("CodigoSolicCompart", data.CodigoSolicCompart);
    methods.setValue("CodigoResponsavelTecnico", data.CodigoResponsavelTecnico);
    methods.setValue("CodigoOcupante", data.CodigoOcupante);
    methods.setValue("Protocolo", data.Protocolo);
    methods.setValue("CodigoTipoVistoria", data.CodigoTipoVistoria);
    methods.setValue("CodigoUsuario", data.CodigoUsuario);
    methods.setValue("Usuario", data.Usuario);
    methods.setValue("DataCadastro", parse(data.DataCadastro, 'dd/MM/yyyy HH:mm:ss', new Date()));
    methods.setValue("DataApresentacao", parse(data.DataApresentacao, 'dd/MM/yyyy HH:mm:ss', new Date()));
    methods.setValue("PrazoAnalise", parse(data.PrazoAnalise, 'dd/MM/yyyy HH:mm:ss', new Date()));
    methods.setValue("DataInicioInstalacao", parse(data.DataInicioInstalacao, 'dd/MM/yyyy HH:mm:ss', new Date()));
    methods.setValue("DataTerminoInstalacao", parse(data.DataTerminoInstalacao, 'dd/MM/yyyy HH:mm:ss', new Date()));
    methods.setValue("DataConclusao", parse(data.DataConclusao, 'dd/MM/yyyy HH:mm:ss', new Date()));
    methods.setValue("GeraServico", data.GeraServico);
    methods.setValue("ParecerAnalise", data.ParecerAnalise);
    methods.setValue("ParecerVistoria", data.ParecerVistoria);
    methods.setValue("Observacao", data?.Observacao);
    methods.setValue("SolicitacaoCompartilhamento", {
      value: data?.CodigoSolicCompart,
      label: `${data?.SolicitacaoCompartilhamento?.CodigoVisual} - ${data?.SolicitacaoCompartilhamento?.Ocupante?.Nome}`
    });
  }

  const handleCadastroSolicFiscalizacao = methods.handleSubmit(async (data) => {
    try {

      if (!data.Id) {
        setIsLoading(true);

        data.CodigoSolicCompart = data?.SolicitacaoCompartilhamento?.value;
        data.CodigoOcupante = solicitacaoCompartilhamento.CodigoOcupante;
        data.CodigoResponsavelTecnico = user.codigoUsuario;

        var dto = {
          CodigoSolicCompart: data?.SolicitacaoCompartilhamento?.value,
          CodigoResponsavelTecnico: user.codigoUsuario,
          CodigoOcupante: solicitacaoCompartilhamento.CodigoOcupante,
          Observacao: data.Observacao,
          DataInicioInstalacao: data.DataInicioInstalacao,
          DataTerminoInstalacao: data.DataTerminoInstalacao
        };

        const response = await servSolicitacaoFiscalizacao.Inserir(dto);

        mapearRetorno(response.Content);

        setTypeAlert("success");
        setOpenError(true);
        setErrorMessage("Dados salvos com sucesso");


        if (fecharAoSalvarRef.current) {
          setTimeout(() => {
            setOpen(false);
          }, [1000]);
        }

        pesquisar();

        setIsLoading(false);
      } else {
        setIsLoading(true);

        data.CodigoSolicCompart = data?.SolicitacaoCompartilhamento.value;
        data.CodigoOcupante = solicitacaoCompartilhamento.CodigoOcupante;
        data.CodigoResponsavelTecnico = user.codigoUsuario;
        data.CodigoSolicitacaoFiscalizacao = data.Id;

        var dto = {
          Id: data.Id,
          SituacaoFiscalizacao: data.SituacaoFiscalizacao,
          NumeroAnalise: data.NumeroAnalise,
          CodigoSolicCompart: data.CodigoSolicCompart,
          CodigoResponsavelTecnico: data.CodigoResponsavelTecnico,
          CodigoOcupante: data.CodigoOcupante,
          Observacao: data.Observacao,
          DataInicioInstalacao: data.DataInicioInstalacao,
          DataTerminoInstalacao: data.DataTerminoInstalacao,
          GeraServico: data.GeraServico
        };

        const response = await servSolicitacaoFiscalizacao.Editar(dto);

        mapearRetorno(response.Content);
        methods.reset({}, { keepValues: true });

        setTypeAlert("success");
        setOpenError(true);
        setErrorMessage("Dados alterados com sucesso");

        if (fecharAoSalvarRef.current) {
          setTimeout(() => {
            setOpen(false);
          }, [1000]);
        }

        pesquisar();

        setIsLoading(false);
      }
    } catch (err) {
      setIsLoading(false);

      setTypeAlert("error");

      return ErrorHandling(
        err?.request?.status,
        err?.message,
        setOpenError,
        setErrorMessage,
        dispatch,
        logout,
        navigate,
        err?.response?.data?.Message
      );
    }
  });

  const handleTabChange = async (event, newValue) => {
    const situacoesNaoEditaveis = [1, 4, 6, 7, 8];

    if (situacoesNaoEditaveis.includes(methods.getValues("SituacaoFiscalizacao"))) {
      setTabIndex(newValue);
      return;
    }

    if (!methods.getValues("Id")) {
      if (!methods.getValues("SolicitacaoCompartilhamento.value")) {
        setErrorMessage("É necessário informar um orçamento de conexão para avançar.");
        return setOpenError(true);
      }

      setFecharAoSalvar(false);
      await handleCadastroSolicFiscalizacao();
      setFecharAoSalvar(true);

      if (Object.keys(methods.formState.errors).length > 0) {
        return;
      }

      await recuperarDocumentosIniciais();

      setTabIndex(newValue);
    } else {
      let houveAlteracaoCampos = Object.keys(methods.formState.dirtyFields).length > 0;

      if (houveAlteracaoCampos) {
        setFecharAoSalvar(false);
        await handleCadastroSolicFiscalizacao();
        setFecharAoSalvar(true);

        if (Object.keys(methods.formState.errors).length > 0) {
          return;
        }
      }

      recuperarDocumentosIniciais();
      setTabIndex(newValue);
    }
  }

  const handleClickOpenDialog = async (event, reason) => {
    try {
      setFecharAoSalvar(false);
      await handleCadastroSolicFiscalizacao();
      setFecharAoSalvar(true);

      if (Object.keys(methods.formState.errors).length > 0) {
        return;
      }

      const docsAtualizados = await recuperarDocumentosIniciais();

      const docsObrigatoriosPendentes = (docsAtualizados ?? documentosObrigatorios).filter(
        doc => doc.Obrigatorio === 1 && !doc.CodigoDocumento
      );

      if (docsObrigatoriosPendentes.length > 0) {
        const nomesDocs = docsObrigatoriosPendentes.map(doc => doc.Descricao).join(', ');
        setTypeAlert("warning");
        setErrorMessage(`Existem documentos obrigatórios pendentes: ${nomesDocs}`);
        setOpenError(true);
        return;
      }

      if (reason === 'clickaway') {
        setOpenDialog(true);
      }

      setOpenDialog(true);
    } catch (err) {
      setOpenDialog(false);
      return setErrorMessage(err?.response?.data?.Message);
    }
  }

  const fecharJanela = () => {
    setEhNovoCadastro(false);
    setOpen(false);
  }

  const handleCloseDialog = (event, reason) => {
    if (reason === 'clickaway') {
      setOpenDialog(false);
    }

    setOpenDialog(false);
  }

  const solicitarAnalise = async () => {
    try {
      setIsLoading(true);

      await servSolicitacaoFiscalizacao.SolicitarAnalise(methods.getValues("Id"));

      setOpenError(true);
      setErrorMessage("Solicitação de análise enviada com sucesso.");
      setIsLoading(false);

      setOpenDialog(false);

      setTimeout(() => {
        setOpen(false);
        pesquisar();
      }, [1400]);

    } catch (err) {
      setIsLoading(false);
      setOpenDialog(false);
      setOpenError(true);
      setTypeAlert("error");

      setErrorMessage(err?.response?.data?.Message);
      return setOpen(true);
    }
  }

  const recuperarDocumentosIniciais = async () => {
    try {
      setIsLoading(true);

      const idSolicFiscalizacao = recordForEdit ? recordForEdit?.id || recordForEdit?.Id : methods.getValues("Id");

      const [docsObrigatorios, docsVinculados] = await Promise.all([
        servParam.RecuperarDocumentosObrigatorios(13),
        servSolicitacaoFiscalizacaoDocs.listar(idSolicFiscalizacao)
      ]);

      const docsAtualizados = mapearCamposDaEdicaoDocs(docsObrigatorios.Content, docsVinculados.Content);

      setIsLoading(false);

      return docsAtualizados;
    } catch (err) {
      setIsLoading(false);

      if (err?.response?.status === 401) {
        setErrorMessage("Token expirado, redirecionando...");
        setOpen(true);
        return setTimeout(() => {
          dispatch(logout());
          navigate("/");
        }, [2000]);
      }

      setErrorMessage(err?.response?.data?.Message);
      setOpen(true);
    }
  }

  const mapearCamposDaEdicaoDocs = (docsObrigatorios, docsVinculados) => {
    const docsAtualizados = docsObrigatorios.map((doc) => {
      const documentoVinculado = docsVinculados?.find(
        (docVinculado) =>
          doc.Id == docVinculado.CodigoConfiguracaoDoc &&
          doc.CodigoClassificacaoDoc == docVinculado.CodigoClassificacaoDoc
      );

      if (documentoVinculado) {
        return {
          ...doc,
          CodigoOcupanteDoc: documentoVinculado.Id,
          CodigoDocumento: documentoVinculado.CodigoDocumento,
          NomeArquivo: documentoVinculado.NomeArquivo,
          Aprovado: documentoVinculado.Aprovado
        };
      }

      return doc;
    });

    setDocumentosObrigatorios(docsAtualizados);

    return docsAtualizados;
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      setOpenError(false);
    }

    setOpenError(false);
  }

  return (
    <div style={{ width: "100%", height: "100%" }}>
      {methods.getValues('Id') && (
        <div>
          <header className={styles.header}>
            <span className={styles.headerData}>
              <div className={styles.dateBox}></div><b>Data de início:</b> {format(methods.getValues("DataInicioInstalacao"), "dd/MM/yyyy", { locale: ptBR })}
            </span>
            <span className={styles.headerData}>
              <div className={`${styles.dateBox} ${styles['dateBox-green']}`}></div><b>Data prazo:</b> {format(methods.getValues("PrazoAnalise"), "dd/MM/yyyy", { locale: ptBR })}
            </span>
          </header>

          <header className={styles.header}>
            <span className={styles.headerData}>
              <div className={`${styles.dateBox} ${styles['dateBox-darkblue']}`}></div><b>Solic. de compartilhamento: </b> {solicitacaoCompartilhamento ? solicitacaoCompartilhamento?.CodigoVisual : ''}
            </span>

            {methods.getValues("Protocolo") && (
              <span className={styles.headerData}>
                <div className={`${styles.dateBox} ${styles['dateBox-gray']}`}></div><b>Protocolo: </b> {methods.getValues("Protocolo")}
              </span>
            )}
          </header>
        </div>
      )}

      <FormProvider {...methods} >
        <form onSubmit={handleCadastroSolicFiscalizacao}>
          <div className={styles.class100}>
            <div className={styles.tabsHeader}>
              <Tabs value={tabIndex} sx={{ width: "95%" }} onChange={handleTabChange} aria-label="abas cadastro de solicitação">
                <Tab sx={{ color: "whitesmoke" }} label="Geral" {...a11yProps(0)} />
                <Tab sx={{ color: "whitesmoke" }} label="Documentos" {...a11yProps(1)} />
              </Tabs>
            </div>

            <TabPanel value={tabIndex} index={0}>
              <Geral
                situacao={situacao}
                recordForEdit={recordForEdit}
              />
            </TabPanel>

            <TabPanel value={tabIndex} index={1}>
              <Documentos
                documentos={documentosObrigatorios}
                setOpenError={setOpenError}
                setErrorMessage={setErrorMessage}
                setIsLoading={setIsLoading}
                codigoSolicFiscalizacao={recordForEdit ? recordForEdit?.id || recordForEdit?.Id : methods.getValues("Id")}
                situacaoSolic={situacao}
              />
            </TabPanel>

          </div>

          <div className={styles['solicitacao-botoes']}>
            <BlueHoverButton type="submit" disabled={!podeSalvar}>Salvar</BlueHoverButton>
            {tabIndex == 1 && (
              <BlueHoverButton onClick={handleClickOpenDialog} disabled={!podeSalvar}>Solicitar análise</BlueHoverButton>
            )}
            <BlueHoverButton onClick={fecharJanela}>Cancelar</BlueHoverButton>
          </div>
        </form>
      </FormProvider>

      <Snackbar open={openError} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} autoHideDuration={6000} onClose={handleClose} >
        <Alert onClose={handleClose} severity={typeAlert} sx={{ width: "100%" }}>
          {errorMessage}
        </Alert>
      </Snackbar>

      <Modal open={isLoading}>
        <Box style={modalstyle}>
          <CircularProgress />
        </Box>
      </Modal>

      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" sx={{ backgroundColor: "#232323", fontWeight: "bold" }}>
          {"Solicitar análise"}
        </DialogTitle>
        <DialogContent sx={{ backgroundColor: "#232323" }}>
          <DialogContentText id="alert-dialog-description" sx={{ color: "whitesmoke" }}>
            Você deseja solicitar a análise da solicitação de fiscalização?
            Após a solicitação, o registro só poderá ser alterado em uma eventual reprovação.
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ backgroundColor: "#232323" }}>
          <BlueHoverButton onClick={handleCloseDialog}>Cancelar</BlueHoverButton>
          <BlueHoverButton autoFocus onClick={solicitarAnalise}>
            Continuar
          </BlueHoverButton>
        </DialogActions>
      </Dialog>
    </div>
  )
}

export { Cadastro }